import { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { StateContext } from 'state/state-context';
import { Container } from 'components/Container/Container';
import { TextHeader } from 'components/Typography/TextHeader';
import { Reveal } from 'components/Reveal/Reveal';
import { Button } from 'components/Form';
import { DescriptionList } from 'components/DescriptionList/DescriptionList';
import { useFormRedirect } from 'hooks/useFormRedirect';
import { useConfirmationApi } from 'hooks/useConfirmationApi';
import { formatMobile, formatSortCode, isInsideMobileApp, continueToApp } from 'utils';

const getIBUrl = (brand) => {
  return `https://${window.__config[`internet_banking_${brand}_url`]}/${brand}`;
};

const navigateToIb = (url) => () => (window.location = url);

const Confirmation = () => {
  const { form, content, brand } = useContext(StateContext);
  const { mobileNumber, sortCode, accountNumber } = form.state;
  useConfirmationApi(form);
  const history = useHistory();
  const hasRequiredFields = useFormRedirect(form, ['accountNumber', 'sortCode', 'mobileNumber']);
  const ibUrl = getIBUrl(brand);

  const onTryAgain = () => {
    form.reset();
    history.push('/');
  };

  if (!hasRequiredFields) {
    return null;
  }

  const didNotGetTextCopy = content(`did_not_get_text.copy_2.${brand}`);

  const insideMobileApp = isInsideMobileApp();

  return (
    <Container>
      <TextHeader icon="tick" data-test="confirmationHeader">
        {content('confirmation_header')}
      </TextHeader>
      <p>{content('confirmation_subHeader')}</p>
      <DescriptionList data-test="confimrmation-data">
        <dt>{content('confirmation_details_header')}</dt>
        <dd className="hide-on-small-only">&nbsp;</dd>
        <dt>{content('mobileNumber.label')}</dt>
        <dd>{formatMobile(mobileNumber.value)}</dd>
        <dt>{content('sortCode.label')}</dt>
        <dd>{formatSortCode(sortCode.value)}</dd>
        <dt>{content('accountNumber.label')}</dt>
        <dd>{accountNumber.value}</dd>
      </DescriptionList>
      <Reveal label={content('did_not_get_text.label')}>
        <p>{content('did_not_get_text.copy')}</p>
        <p>{didNotGetTextCopy}</p>
        <Button outline label={content('did_not_get_text.try_again')} onClick={onTryAgain}></Button>
      </Reveal>
      {!insideMobileApp && (
        <Button label={content('signInToIbButton')} onClick={navigateToIb(ibUrl)}></Button>
      )}
      {insideMobileApp && (
        <Button label={content('continueToAppButton')} onClick={continueToApp}></Button>
      )}
    </Container>
  );
};

export { Confirmation };
